import api from "../../api/axios.config";
import { setSchedules } from "../slices/payment";

export const getSchedules = () => {
  return async (dispatch) => {
    const response = await api.get(`/api/schedules`);
    if(response.status === 200)
        dispatch(setSchedules(response.data?.schedules ?? []));
  }
}